import React from 'react';
import Section from '../../components/ui/Section';
import { motion } from 'framer-motion';

const Impressum = () => (
  <div className="pt-32">
    <Section className="bg-dark">
      <div className="max-w-3xl mx-auto">
        <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="text-gold tracking-widest uppercase text-sm mb-4">Legal</motion.p>
        <motion.h1 initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="text-5xl font-serif text-cream mb-12">Impressum</motion.h1>
        <div className="space-y-8 text-cream/65 font-light text-lg leading-relaxed">
          <div>
            <h2 className="text-xl font-serif text-cream mb-3">Angaben gemäß § 5 TMG</h2>
            <p>Jennifer Gräser<br />Coaching Female<br />Musterstraße 1<br />12345 Musterstadt</p>
          </div>
          <div>
            <h2 className="text-xl font-serif text-cream mb-3">Kontakt</h2>
            <p>E-Mail: hallo@coachingfemale.com<br />Telefon: +49 (0) 123 456 789</p>
          </div>
          <div>
            <h2 className="text-xl font-serif text-cream mb-3">Umsatzsteuer-ID</h2>
            <p>Umsatzsteuer-Identifikationsnummer gemäß § 27a Umsatzsteuergesetz: DE123456789</p>
          </div>
          <div>
            <h2 className="text-xl font-serif text-cream mb-3">Haftungsausschluss</h2>
            <p>Die Inhalte dieser Website wurden mit größtmöglicher Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte kann keine Gewähr übernommen werden.</p>
          </div>
        </div>
      </div>
    </Section>
  </div>
);

export default Impressum;